<template>
  <div :class="['contract-filter-select', skin === 'dark' ? 'dark-theme' : 'light-theme']">
    <multiselect
      :id="id"
      :value="selectedOptions"
      :options="groupedOptions"
      :loading="loading"
      :disabled="disabled"
      label="name"
      track-by="filterKey"
      group-values="items"
      group-label="label"
      group-select
      multiple
      :close-on-select="false"
      :show-labels="false"
      :placeholder="placeholder"
      @input="$emit('input', $event.map(option => option.filterKey))"
    >
      <template #noOptions>
        Essa lista está vazia
      </template>
      <template #noResult>
        Nenhum dado encontrado
      </template>
      <template #selection="{ values }">
        <span
          v-if="values.length >= 10"
          class="multiselect__single"
        >
          {{ values.length }} opções selecionadas
        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import useAppConfig from '@core/app-config/useAppConfig'

// Fora do componente: em `data()` o rótulo se perderia quando o sidebar remonta os selects.
const seenNames = new Map()

export default {
  components: { Multiselect },
  setup() {
    const { skin } = useAppConfig()
    return { skin }
  },
  props: {
    id: { type: String, required: true },
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    takeThis: { type: String, default: 'id' },
    placeholder: { type: String, default: '' },
    loading: Boolean,
    disabled: Boolean,
  },
  computed: {
    normalizedOptions() {
      return this.options.map(option => ({ ...option, filterKey: option[this.takeThis] }))
    },
    groupedOptions() {
      return [{ label: '', items: this.normalizedOptions }]
    },
    selectedOptions() {
      return this.value.map(key => this.normalizedOptions.find(option => String(option.filterKey) === String(key))
        || { name: seenNames.get(`${this.id}:${key}`) || String(key), filterKey: key })
    },
  },
  watch: {
    normalizedOptions: {
      immediate: true,
      handler(options) {
        options.forEach(option => {
          if (option.name) seenNames.set(`${this.id}:${option.filterKey}`, option.name)
        })
      },
    },
  },
}
</script>

<style lang="scss">
@import "~vue-multiselect/dist/vue-multiselect.min.css";
@import "@core/scss/vue/libs/all-select.scss";

.contract-filter-select {
  .multiselect,
  .multiselect__tags {
    min-height: 2.714rem;
  }

  .multiselect__tags {
    border-radius: 0.357rem;
  }

  .multiselect__select {
    height: calc(2.714rem - 2px);
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") center / 15px no-repeat;

    &::before {
      display: none;
    }
  }

  .multiselect__placeholder {
    margin-bottom: 8px;
    padding-top: 0;
    color: #6e6b7b;
  }

  .multiselect--active .multiselect__tags {
    border-color: #f26237;
  }

  &.dark-theme {
    .multiselect__select {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
    }

    .multiselect__placeholder {
      color: #676d7d;
    }
  }
}
</style>
